<app-card-consulta 
  (update)="update.emit($event)" 
  [titulo]="titulo" 
  [idConsulta]='idConsulta' 
  [tipoConsulta]="tipoConsulta" 
  [codigoControle]="codigoControle"
  [status]="status"
  [msg]="statusMsg"
>

  <ng-container *ngIf="consulta">
      
    <ul class="card-list-striped py-1">
      <li>
        <span class="text-secondary">CPF:</span>
        <span class="text-uppercase">{{ consulta?.cpf || msgNull }} </span>
      </li>
      <li>
        <span class="text-secondary">ORIGEM DO CPF:</span>
        <span class="text-uppercase">{{ consulta?.origem_cpf || msgNull }}</span>
      </li>
      <li>
        <span class="text-secondary">SITUAÇÃO DO CPF:</span>
        <span class="text-uppercase">
          {{consulta?.situacao_cpf || msgNull}} 
          {{consulta?.emissao_situacao_cpf != 'Sem detalhamento' ? ' em ' + consulta?.emissao_situacao_cpf : ''}}
        </span>
      </li>
      <li>
        <span class="text-secondary">NOME:</span>
        <span class="text-uppercase">{{ consulta?.nome || consulta?.nomePessoa || msgNull }}</span>
      </li>
      <li>
        <span class="text-secondary">E-MAIL:</span>
        <span class="text-uppercase">{{ consulta?.email || msgNull }}</span>
      </li>
      <li>
        <span class="text-secondary">DATA DE NASCIMENTO:</span>
        <span class="text-uppercase">{{ consulta?.data_nascimento || msgNull }}</span>
      </li>
      <li>
        <span class="text-secondary">SIGNO:</span>
        <span class="text-uppercase">{{ consulta?.signo || msgNull }}</span>
      </li>
      <li>
        <span class="text-secondary">SEXO:</span>
        <span class="text-uppercase">{{ consulta?.sexo || msgNull }}</span>
      </li>
      <li>
        <span class="text-secondary">NOME DA MÃE:</span>
        <span class="text-uppercase">{{ consulta?.nome_mae || msgNull }}</span>
      </li>
      <li>
        <span class="text-secondary">ESTADO CIVIL:</span>
        <span class="text-uppercase">{{ consulta?.estado_civil || msgNull }}</span>
      </li>
    </ul>

  </ng-container>

</app-card-consulta>